module.exports = __webpack_public_path__ + "img/roll_tips.2b9f1462.png";